import { isSvgSupported } from "../browserHelper";
import { images } from "../imageHelpers/images";

export type ExtensionType = "png" | "svg" | "jpg" | "gif" | "json";

function getSource(
  folderPath: Map<string, string>,
  name: string,
  extension: ExtensionType,
): string {
  const imageName = `${name}_${extension}`;

  if (folderPath.has(imageName)) {
    return folderPath.get(imageName)!;
  }

  throw new Error(`Image not found: ${imageName}`);
}

/**
 * Get the image source path for a given image name
 * @param name The image name
 * @param extension The file extenstion of the image
 * @returns The source path
 */
export function getImageSource(
  name: string,
  extension: ExtensionType = isSvgSupported ? "svg" : "png",
) {
    return getSource(images, name, extension);
}
